module.exports = __webpack_public_path__ + "assets/details-other-currency.81f3a337.svg";